export const CustomReactSelectStyles = (isDarkMode: boolean) => ({
  control: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isDisabled
      ? '#eff2f7'
      : isDarkMode
      ? '#262A2F'
      : '#fff', // Dark/Light mode background
    borderColor: state.isDisabled
      ? '#eff2f7'
      : state.isFocused
      ? isDarkMode
        ? '#fff' // White border on focus in dark mode
        : '#b0c4de' // Light blue border on focus in light mode
      : isDarkMode
      ? '#262A2F'
      : '#ddd', // Default border color
    boxShadow: state.isFocused
      ? isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)' // White shadow in dark mode
        : '0 0 5px rgba(0, 0, 255, 0.2)' // Blue shadow in light mode
      : styles.boxShadow,
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
      borderColor: state.isDisabled
        ? '#eff2f7'
        : isDarkMode
        ? '#fff'
        : '#b0c4de',
      boxShadow: state.isDisabled
        ? 'none'
        : isDarkMode
        ? '0 0 5px rgba(255, 255, 255, 0.5)'
        : '0 0 5px rgba(0, 0, 255, 0.2)',
    },
    outline: 'none',
    cursor: state.isDisabled ? 'not-allowed' : 'default',
  }),
  placeholder: (styles: any, state: any) => ({
    ...styles,
    color: state.isDisabled ? '#a0a0a0' : '#878A99', // Grey when disabled
  }),
  singleValue: (styles: any, state: any) => ({
    ...styles,
    color: state.isDisabled
      ? '#a0a0a0' // Grey text when disabled
      : isDarkMode
      ? '#fff'
      : '#333',
  }),
  option: (styles: any, state: any) => ({
    ...styles,
    backgroundColor: state.isSelected
      ? '#4bb189'
      : state.isFocused
      ? '#4bb18980'
      : 'transparent',
    color: state.isSelected ? '#fff' : isDarkMode ? '#ffffff' : '#000000',
    padding: 10,
    ':hover': !state.isDisabled && {
      backgroundColor: '#4bb189',
      color: '#fff',
    },
  }),
});
